var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.325 25.302c.626-.946.903-1.983.796-2.881-.078-.658-.084-1.564.295-2.108l5.741-8.238c.38-.543.708-.963.734-.937l.047.047c.73.726 1.984.718 3.118.076.577-.326.571-1.105.101-1.574L20.28.842c-.47-.468-1.251-.475-1.58.1-.642 1.13-.651 2.38.079 3.108l.047.047c.025.025-.396.353-.942.73L9.617 10.55c-.545.378-1.455.373-2.114.294-.902-.107-1.943.17-2.893.793-.555.365-.548 1.137-.079 1.605l5.262 5.244-5.844 5.823.013.013C1.62 26.781.136 28.983.578 29.423c.44.44 2.65-1.04 5.12-3.373l.013.014 5.844-5.824 5.159 5.141c.47.468 1.245.475 1.611-.079"
  })));
};
export default SvgPin;